import { AppBar, Toolbar, Typography, Button, Badge, IconButton, Box } from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useCart } from '../context/CartContext';
import { Link } from 'react-router-dom';
import logo from '../store_logo/zebra.jpg';
import SearchBar from './Search';

function Navbar() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const { cartCount } = useCart();
  const location = useLocation();

  const showSearchBar = location.pathname === '/' ||
                        location.pathname.startsWith('/search');

  const logoColor = '#333333';

  // Check if user is admin
  const isAdmin = user?.role === 'admin' || localStorage.getItem('admin_token');

  // Admin logout
  const handleAdminLogout = () => {
    localStorage.removeItem('admin_token');
    navigate('/admin/login');
  };

  return (
    <AppBar
      position="static"
      sx={{
        backgroundColor: logoColor,
      }}
    >
      <Toolbar>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            flexGrow: 1,
            cursor: 'pointer'
          }}
          onClick={() => navigate('/')}
        >
          <img
            src={logo}
            alt="ZebraStore Logo"
            style={{ height: '40px', marginRight: '10px' }}
          />
          <Typography variant="h6" component="div">
            ZebraStore
          </Typography>
        </Box>

        {/* Products Button - Only show if NOT admin */}
        {!isAdmin && (
          <Button
            color="inherit"
            component={Link}
            to="/"
            sx={{
              mx: 2,
              fontWeight: 'bold',
              display: 'block'
            }}
          >
            Products
          </Button>
        )}

        {showSearchBar && !isAdmin && <SearchBar />}

        {/* Admin Navigation */}
        {isAdmin ? (
          <Button color="inherit" onClick={handleAdminLogout}>
            Logout
          </Button>
        ) : (
          /* Regular User Navigation */
          user ? (
            <>
              <Button color="inherit" onClick={() => navigate('/orders')}>
                Orders
              </Button>
              <IconButton color="inherit" component={Link} to="/cart">
                <Badge badgeContent={cartCount} color="error">
                  <ShoppingCartIcon />
                </Badge>
              </IconButton>
              <Button color="inherit" onClick={logout}>
                Logout
              </Button>
            </>
          ) : (
            /* Guest Navigation */
            <>
              <Button color="inherit" onClick={() => navigate('/login')}>
                Login
              </Button>
              <Button color="inherit" onClick={() => navigate('/register')}>
                Register
              </Button>
            </>
          )
        )}
      </Toolbar>
    </AppBar>
  );
}

export default Navbar;
